import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ContentBox } from "src/components/ContentBox";
import { WaterDrop } from "src/components/Icons";

const windowWidth = window.innerWidth;
const blockWidth = windowWidth < 1400 ? 50 : 25;

export function WaterConsumptionSensor() {
  const { t } = useTranslation();
  const [sensor, setSensor] = useState({ signal: 48, defined: 2000 });

  useEffect(() => {
    const interval = setInterval(() => {
      setSensor((prevSensor) =>
        prevSensor.signal === 0
          ? { ...prevSensor, signal: 34 }
          : { ...prevSensor, signal: prevSensor.signal + 1 }
      );
    }, 1000);

    return () => {
      clearTimeout(interval);
    };
  }, []);

  return (
    <ContentBox
      width={`${blockWidth}%`}
      padding={12}
      title={t("water")}
      description={t("consumption_gallons_hour")}
      amount={sensor.signal}
      amountName={t("actual")}
      totalAmount={2000}
      totalName={t("avg_per_day")}
      icon={<WaterDrop />}
      res="-8%"
      resType="norm"
    />
  );
}
